<template >
    <div id="tabs-body">
        <PlotBody 
            v-if="widgetType === 'plot'"
            :data="data"
        />
        <ModelsBody 
            v-else-if="widgetType === 'models' && data.items"
            :data="data"
        />
        <ConfTourModelsBody 
            v-else-if="widgetType === 'conf-models'"
            :data="data"
        />
        <DocumentationBody 
            v-else-if="widgetType === 'documentation'"
            :data="data"
        />
        <ProgramBody 
            v-else-if="!widgetsWithSpecificNavbar.includes(widgetType)"
            :data="data"
        />
        <v-divider/>
    </div>
</template>

<script>
    import ProgramBody from '@/layout/alternative/program/ProgramBody';
    import PlotBody from '@/layout/alternative/plot/PlotBody';
    import ModelsBody from '@/layout/alternative/models/ModelsBody';
    import DocumentationBody from '@/layout/alternative/documentation/DocumentationBody';
    import ConfTourModelsBody from '../configurableTour/components/ConfTourModelsBody';

    export default {
        name: "BodyLayout",
        components:{
            ProgramBody,
            PlotBody,
            ModelsBody,
            DocumentationBody,
            ConfTourModelsBody
        },
        props: {
            data: {
                type: Object,
                required: true
            }
        },
        computed: {
            widgetType() {
                return this.$props.data && this.$props.data.type ? this.$props.data.type : null
            }
        },
        data: () => ({
            widgetsWithSpecificNavbar: [
                'plot',
                'models',
                'conf-models',
                'documentation',
            ],
        })
    }
</script>


// WEBPACK FOOTER //
// src/layout/alternative/layout/BodyLayout.vue